<template>
  <BaseSvg class="red-x-icon" viewBox="0 0 24 24" fill="none">
    <line
      x1="0.88938"
      y1="-0.88938"
      x2="24.1277"
      y2="-0.88938"
      transform="matrix(-0.703174 -0.711018 0.703174 -0.711018 21.3477 20.1582)"
      stroke="#FF957D"
      stroke-width="1.77876"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="0.88938"
      y1="-0.88938"
      x2="24.1277"
      y2="-0.88938"
      transform="matrix(-0.703174 0.711018 -0.703174 -0.711018 19.9648 2.37109)"
      stroke="#FF957D"
      stroke-width="1.77876"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>

<script setup lang="ts">
import { BaseSvg } from '..';
</script>
